import { Component, computed, input } from '@angular/core';
import { GraphNodeView, labelFor, roleLabel } from '../../engine/engine-case.mapper';
import { WorkflowGraph } from '../../../../../services/workflow-engine/generated/models/workflow-graph';

export interface PublishedGraphAction {
  id: string;
  description: string;
  role: string;
  status: string;
  statusLabel: string;
}

@Component({
  selector: 'app-workflow-published-graph',
  templateUrl: './workflow-published-graph.component.html',
  styleUrl: './workflow-published-graph.component.scss',
})
export class WorkflowPublishedGraphComponent {
  graph = input.required<WorkflowGraph>();
  nodes = input.required<readonly GraphNodeView[]>();
  actions = input<readonly PublishedGraphAction[]>([]);
  readonly labelFor = labelFor;
  readonly roleLabel = roleLabel;
  readonly statusLabels = { done: 'Done', active: 'Current', upcoming: 'Pending', skipped: 'Not reached' };
  titles = computed(() => new Map(this.graph().nodes.map(node => [node.id, node.title ?? labelFor(node.id)])));
}